<template>
  <main class="grid min-h-screen place-items-center bg-surface px-6">
    <form class="w-full max-w-sm space-y-5" @submit.prevent="submit">
      <p class="text-sm font-semibold text-brand-700">Lymon</p>
      <h1 class="text-2xl font-semibold text-ink">{{ t('projectRuntime.operatorLogin') }}</h1>
      <p class="text-sm text-muted">{{ t('projectRuntime.operatorHelp') }}</p>
      <label class="block text-sm">{{ t('projectRuntime.workspace') }}<input v-model="tenant" required autocomplete="organization" class="mt-1 block w-full rounded border border-line bg-surface p-2" /></label>
      <label class="block text-sm">{{ t('projectRuntime.username') }}<input v-model="username" required autocomplete="username" class="mt-1 block w-full rounded border border-line bg-surface p-2" /></label>
      <label class="block text-sm">{{ t('projectRuntime.password') }}<input v-model="password" required type="password" autocomplete="current-password" class="mt-1 block w-full rounded border border-line bg-surface p-2" /></label>
      <p v-if="failed" role="alert" class="text-sm text-danger">{{ t('projectRuntime.loginFailed') }}</p>
      <Button type="submit" :disabled="busy">{{ t('projectRuntime.signIn') }}</Button>
    </form>
  </main>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from '../components/Button.vue';
import { useAuthStore } from '../stores/auth';
const {t}=useI18n(),auth=useAuthStore();
const tenant=ref(''),username=ref(''),password=ref(''),busy=ref(false),failed=ref(false);
async function submit(){busy.value=true;failed.value=false;try{await auth.operatorLogin(tenant.value,username.value,password.value);}catch{failed.value=true;}finally{password.value='';busy.value=false;}}
</script>
